/**
 * Green palette for the "already enrolled" pill and action chip on program
 * cards.
 *
 * Hard-coded rather than read from --theme-*-success because every surface
 * that uses it (the featured hero, the grid card's thumbnail strip) paints its
 * own dark navy background in BOTH themes -- the light-theme success token
 * (#008236 on #DCFCE7) is a pale chip that fights that background. These
 * values match the dark-theme success tokens, which is the palette those
 * surfaces actually sit in whichever theme is active.
 *
 * Theme-following surfaces (the landing page's sidebar action card) should use
 * the bg-theme-bg-success / text-theme-text-success utilities instead, not
 * this.
 *
 * Kept in its own module so both card components can share it without either
 * importing the other, and without a non-component export sitting in a
 * component file (which breaks Fast Refresh).
 */
export const ENROLLED_GREEN = {
  bg: "rgba(16,185,129,0.18)",
  border: "rgba(52,211,153,0.35)",
  text: "#34d399",
} as const;
